import { type ReactNode, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { ActiveConversationProvider } from '../../contexts/ActiveConversationContext';
import { MobileDrawerProvider } from '../../contexts/MobileDrawerContext';
import { useTheme } from '../../contexts/ThemeContext';
import { LANG_FONTS, type SupportedLang } from '../../i18n';
import { LeftSidebar } from './LeftSidebar';
import { Scrim } from './Scrim';

export function AppShell({ children }: { children: ReactNode }) {
  const { theme } = useTheme();
  const { i18n } = useTranslation();
  const { id } = useParams();
  const paramId = id ?? 'new';

  // Sync body font with current language.
  useEffect(() => {
    const lang = (i18n.resolvedLanguage as SupportedLang) || 'en';
    const ff = LANG_FONTS[lang] ?? LANG_FONTS.en;
    document.body.style.setProperty('--ff', ff);
    document.documentElement.lang = lang;
  }, [i18n.resolvedLanguage]);

  return (
    <MobileDrawerProvider>
      <div className={`app theme-${theme}`}>
        {/* key={paramId} so each conversation gets a clean state container.
          /c/new persists across the lazy-create flow because we don't navigate
          until run_finish — see ActiveConversationContext.send. */}
        <ActiveConversationProvider key={paramId} paramId={paramId}>
          <LeftSidebar />
          {children}
          <Scrim />
        </ActiveConversationProvider>
      </div>
    </MobileDrawerProvider>
  );
}
